/**
 * Pollo 按模型单独封装，统一入口
 */
import { buildBody as buildSeedance15ProBody } from './seedance-1-5-pro'
import { buildBody as buildWan22PlusBody } from './wan-2-2-plus'
import { buildBody as buildWan25PreviewBody } from './wan-2-5-preview'
import { buildBody as buildWan26Body } from './wan-2-6'
import { buildBody as buildKlingV25TurboBody } from './kling-v2-5-turbo'
import { buildBody as buildKlingV26Body } from './kling-v2-6'
import { buildBody as buildSora2Body } from './sora-2-pollo'
import { buildBody as buildMinimaxHailuo23Body } from './minimax-hailuo-2-3'
import { buildBody as buildVeo3Body } from './veo-3-pollo'
import { buildBody as buildRunwayGen4TurboBody } from './runway-gen-4-turbo'
import { buildBody as buildVeo31Body } from './veo-3-1'
import { buildBody as buildVeo31FastBody } from './veo-3-1-fast'
import { buildBody as buildWanV22FlashBody } from './wan-v2-2-flash'
import { buildBody as buildViduQ3ProBody } from './vidu-q3-pro'

var BUILDERS = {
  'seedance-1-5-pro': buildSeedance15ProBody,
  'wan-2-2-plus': buildWan22PlusBody,
  'wan-2-5-preview': buildWan25PreviewBody,
  'wan-2-6': buildWan26Body,
  'kling-v2-5-turbo': buildKlingV25TurboBody,
  'kling-v2-6': buildKlingV26Body,
  'sora-2-pollo': buildSora2Body,
  'minimax-hailuo-2-3': buildMinimaxHailuo23Body,
  'veo-3-pollo': buildVeo3Body,
  'runway-gen-4-turbo': buildRunwayGen4TurboBody,
  'veo-3-1': buildVeo31Body,
  'veo-3-1-fast': buildVeo31FastBody,
  'wan-v2-2-flash': buildWanV22FlashBody,
  'vidu-q3-pro': buildViduQ3ProBody
}

/**
 * 根据 modelId 构建该模型对应的请求 body
 * @param {string} modelId
 * @param {Object} params - 统一前端参数
 * @returns {{ input: Object, webhookUrl?: string }}
 */
export function buildBody(modelId, params) {
  var fn = BUILDERS[modelId]
  if (!fn) throw new Error('Unknown Pollo model: ' + modelId)
  return fn(params)
}

/**
 * 解析 Pollo 状态接口返回（各模型通用）
 * 响应格式：{ code, message, data: { taskId, generations: [{ id, status, failMsg, url, mediaType, createdDate, updatedDate }] } }
 * status: waiting | succeed | failed | processing
 */
export function parsePolloStatus(res) {
  var list = (res && res.generations) || (res && res.data && res.data.generations)
  if (!list || !list.length) return { status: 'waiting' }
  var gen = list[0]
  var s = gen.status
  if (s === 'succeed') return { status: 'completed', url: gen.url || undefined }
  if (s === 'failed') return { status: 'failed', error: gen.failMsg || '生成失败' }
  return { status: s === 'processing' ? 'processing' : 'waiting' }
}

export { buildBody as buildSeedance15ProBody } from './seedance-1-5-pro'
export { buildBody as buildWan22PlusBody } from './wan-2-2-plus'
export { buildBody as buildWan25PreviewBody } from './wan-2-5-preview'
export { buildBody as buildWan26Body } from './wan-2-6'
export { buildBody as buildKlingV25TurboBody } from './kling-v2-5-turbo'
export { buildBody as buildKlingV26Body } from './kling-v2-6'
export { buildBody as buildSora2Body } from './sora-2-pollo'
export { buildBody as buildMinimaxHailuo23Body } from './minimax-hailuo-2-3'
export { buildBody as buildVeo3Body } from './veo-3-pollo'
export { buildBody as buildRunwayGen4TurboBody } from './runway-gen-4-turbo'
export { buildBody as buildVeo31Body } from './veo-3-1'
export { buildBody as buildVeo31FastBody } from './veo-3-1-fast'
export { buildBody as buildWanV22FlashBody } from './wan-v2-2-flash'
export { buildBody as buildViduQ3ProBody } from './vidu-q3-pro'
